import styled from "styled-components";

export const SmallInputStyled = styled.div`
  flex-grow: 1;

  border-radius: 8px;
  width: 100%;
  overflow: hidden;

  position: relative;

  input {
    padding: 2px 7px;
  }
  .small-input__label {
    position: absolute;
    top: 0;
    left: 6px;
    display: flex;
    align-items: center;
  }
`;
